<ca-standard-meeting-list
  (conversationIdChange)="onConversationIdChanged($event)"
  (dataLoaded)="onDataLoaded()"
  [compactPlayer]="compactPlayer"></ca-standard-meeting-list>
